import ColorAdvancedView from './ColorAdvancedView'

export default ColorAdvancedView
